/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  FooterService,
  IFooterMethods,
  FeatureSectionService,
  IFeatureSectionMethods,
  StaticPageContentService,
  IStaticPageContentMethods,
  IFormatPolicyDetailMethods,
  FormatPolicyDetailService,
  IFormatTimelineDetailMethods,
  FormatTimelineDetailService,
  IBlockchainProofMethods,
  BlockchainProofService,
  IGetTransactionListMethods,
  GetTransactionListService
} from "./components";

export type ActualDetailAgent = IHeaderMethods &
  IFeatureSectionMethods &
  IFooterMethods &
  IStaticPageContentMethods &
  IFormatPolicyDetailMethods &
  IFormatPolicyDetailMethods &
  IBlockchainProofMethods &
  IGetTransactionListMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new FeatureSectionService(),
    new FooterService(),
    new StaticPageContentService(),
    new FormatPolicyDetailService(),
    new FormatTimelineDetailService(),
    new BlockchainProofService(),
    new GetTransactionListService(),
  ];
};

export const getAgent = () => {
  return createAgent<ActualDetailAgent>({
    plugins: getPlugins(),
  });
};
